var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{class:_vm.className,attrs:{"title":_vm.info,"type":"warning","show-icon":"","closable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }